import React from 'react';

const Home = () => {
    return (
        <div>
            <div id='bestDayEver'></div>
            <div id='bestDayLocation'>
                <div id='marganFamily'>MARGAN FAMILY WINES</div>
                <div id='address'>1238 Milbrodale Road, Broke</div>
                <div id='postcodeContainer' class='clearfix'>
                    <div class='hr'></div>
                    <div id='postcode'>2230</div>
                    <div class='hr'></div>
                </div>
            </div>
        </div>
    );
};

export default Home;